export default async function getAllChamados() {
    try {
        const response = await fetch(`${process.env.REACT_APP_SERVER_IP}/Chamados`);
        
        if (!response.ok) {
            throw new Error(`Erro: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error("Erro ao buscar chamados:", error);
        return [];
    }
}